import ENVIRONMENT_VARIABLES from 'src/constants/environment-variables';
import { APP_NAME, APP_NAME_SHORT } from 'src/constants/generic-constants';

export const getTitlePrefix = (): string => {
  const stage = ENVIRONMENT_VARIABLES.env.Stage;
  switch (stage) {
    case 'dev':
      return '[Local] ';
    case 'alpha':
      return '[Alpha] ';
    case 'beta':
      return '[Beta] ';
    case 'prod':
      return '';
    default:
      return '';
  }
};

export const getDocumentTitle = (): string => {
  const prefix = getTitlePrefix();
  return `${prefix}${APP_NAME} (${APP_NAME_SHORT})`;
};
